"use strict";

exports.__esModule = true;
var _ElementActionControlGroup = require("./ElementActionControlGroup");
Object.keys(_ElementActionControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementActionControlGroup[key]) return;
  exports[key] = _ElementActionControlGroup[key];
});
var _ElementCanvasSizeControlGroup = require("./ElementCanvasSizeControlGroup");
Object.keys(_ElementCanvasSizeControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementCanvasSizeControlGroup[key]) return;
  exports[key] = _ElementCanvasSizeControlGroup[key];
});
var _ElementClipboardControlGroup = require("./ElementClipboardControlGroup");
Object.keys(_ElementClipboardControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementClipboardControlGroup[key]) return;
  exports[key] = _ElementClipboardControlGroup[key];
});
var _ElementColorControlGroup = require("./ElementColorControlGroup");
Object.keys(_ElementColorControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementColorControlGroup[key]) return;
  exports[key] = _ElementColorControlGroup[key];
});
var _ElementColorSourceControlGroup = require("./ElementColorSourceControlGroup");
Object.keys(_ElementColorSourceControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementColorSourceControlGroup[key]) return;
  exports[key] = _ElementColorSourceControlGroup[key];
});
var _ElementFontControlGroup = require("./ElementFontControlGroup");
Object.keys(_ElementFontControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementFontControlGroup[key]) return;
  exports[key] = _ElementFontControlGroup[key];
});
var _ElementPositionControlGroup = require("./ElementPositionControlGroup");
Object.keys(_ElementPositionControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementPositionControlGroup[key]) return;
  exports[key] = _ElementPositionControlGroup[key];
});
var _ElementSizeControlGroup = require("./ElementSizeControlGroup");
Object.keys(_ElementSizeControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementSizeControlGroup[key]) return;
  exports[key] = _ElementSizeControlGroup[key];
});
var _ElementUndoControlGroup = require("./ElementUndoControlGroup");
Object.keys(_ElementUndoControlGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementUndoControlGroup[key]) return;
  exports[key] = _ElementUndoControlGroup[key];
});